<template>
  <v-container fluid>
    <h1 class="text-center my-5">{{ $t('title') }}</h1>
    <v-row v-blur="blurConfig" align="center" justify="center">
      <p class="mr-3 mt-n1">{{ $t('subtitlePrepend') }} </p>
      <v-select :label="$t('label')" style="max-width: 21%;" :items="brokerAccounts" item-value="id" v-model="brokerAccountSelected" @change="accountChanged" dense outlined>
        <template v-slot:selection="data">
          {{ (data.item.broker.name !== 'All')? ((data.item.identifier !== '')? data.item.identifier : data.item.broker.name): 'All' }}
          <v-icon v-if="data.item.verified" color="blue" class="ml-2" small>fa-check-circle</v-icon>
        </template>
        <template v-slot:item="data">
          {{ (data.item.identifier !== '')? `${data.item.broker.name} · ${data.item.identifier}` :  data.item.broker.name }}
          <v-icon v-if="data.item.verified" color="blue" class="ml-2" small>fa-check-circle</v-icon>
        </template>
      </v-select>
      <p class="ml-3 mt-n1">{{ $tc('subtitleAppend', (brokerAccountSelected === 'All')? 2 : 1) }}</p>
    </v-row>
    <v-row v-blur="blurConfig" v-if="brokerAccountSelected !== 'All'" align="center" justify="center">
      <p class="my-0 mr-3">{{ $t('tradingPlan.prepend') }}</p>
      <v-btn class="button-plan" @click="openTradingPlan">{{ $t('tradingPlan.btnTradingPlan') }} <v-icon class="ml-2" color="white" small>fa-swatchbook</v-icon></v-btn>
    </v-row>
    <InsightsSummary v-blur="blurConfig" :insights="selectedInsights" :full="true"/>
    <LargeCardAd v-if="ad !== null" :ad="ad"/>

    <!-- Overlay for CTA upgrade to pro !-->
    <v-overlay v-model="canSeeInsights" absolute opacity="0">
      <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="seeProAdvantages = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import AdEngine from '../../ads/adEngine';

import Repository from '../../repositories/insights';
import InsightsSummary from "@/views/Mentor/components/InsightsSummary";
import UpgradeToPro from "@/components/UpgradeToPro";
import LargeCardAd from "@/ads/LargeCardAd";
export default {
  name: "MentorIndex",
  components: {LargeCardAd, UpgradeToPro, InsightsSummary},
  data() {
    return {
      // Ads
      ad: null,

      blurConfig: {
        isBlurred: !this.$store.state.user.isPro,
        opacity: 0.1,
        filter: "blur(1.2px)",
        transition: "all .3s linear"
      },
      canSeeInsights: !this.$store.state.user.isPro,
      messageUpgradeToPro: this.$t('ctaUpgradeToPro'),

      brokerAccounts: [],
      brokerAccountSelected: 'All',
      allInsights: [],
      selectedInsights: [],

      overlayTradingPlan: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    retrieveAd() {
      this.ad = AdEngine.getRandomAd('Large Ad');
    },
    init() {
      this.retrieveAd();

      Repository.getUserInsights().then((response) => {
        if(response.status < 400) {
          this.allInsights = [];
          response.data.forEach((insight) => {
            this.allInsights.push(JSON.parse(insight));
          });
          this.updateBrokerAccounts();
        }
      });
    },
    accountChanged() {
      if(this.brokerAccountSelected === 'All')
        this.selectedInsights = this.allInsights.find((insightsData) => insightsData.id === -1);
      else
        this.selectedInsights = this.allInsights.find((insightsData) => insightsData.id === this.brokerAccountSelected);
      // eslint-disable-next-line no-console
      console.log(this.selectedInsights);
    },
    updateBrokerAccounts() {
      this.brokerAccounts = [{broker: {name: 'All'}, identifier: '', id: 'All'}];
      let accountsIds = [];
      if(this.allInsights.length > 0) {
        this.selectedInsights = this.allInsights[this.allInsights.length - 1];
        accountsIds = this.allInsights.map((object) => { return object["id"] });
        accountsIds.forEach((id) => {
          let accountFound = this.$store.state.user.brokerAccounts.find((account) => account.id === id);
          if(accountFound !== undefined)
            this.brokerAccounts.push(accountFound);
        });
      }
      this.brokerAccountSelected = 'All';
    },
    openTradingPlan() {
      this.$router.push('/plan');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Trading Mentor",
    "subtitlePrepend": "Insights for",
    "label": "Broker Account",
    "subtitleAppend": "account | accounts",
    "ctaUpgradeToPro": "With pro you can get unlimited trading insights.",
    "tradingPlan": {
      "prepend": "See your account plan",
      "btnTradingPlan": "Trading Plan"
    }
  },
  "es": {
    "title": "Mentor de Trading",
    "subtitlePrepend": "Insights para",
    "label": "Cuenta de Broker",
    "subtitleAppend": "cuenta | cuentas",
    "ctaUpgradeToPro": "Con pro podrás obtener ilimitados insights de tú operativa.",
    "tradingPlan": {
      "prepend": "Observa el plan de tu cuenta",
      "btnTradingPlan": "Plan de Trading"
    }
  }
}
</i18n>

<style scoped>
  .button-plan {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }
</style>
